// @flow

import React from 'react';
import {
  Price,
  Actions,
} from './atoms';
import { Footer } from './footer.styled';

type Props = {
  price: number,
  displayActions: ?boolean,
};

export default ({ price, displayActions }: Props) => (
  <Footer>
    <Price amount={price} />
    {displayActions && <Actions />}
  </Footer>
);
